import { render, staticRenderFns } from "./LvFlexBox.vue?vue&type=template&id=2230a17f"
import script from "./LvFlexBox.vue?vue&type=script&lang=js"
export * from "./LvFlexBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports